import {useRouter} from 'next/router';
import dynamic from 'next/dynamic';
import {
  getIndividualPageData,
  getPageInfo,
  fetchAPIRequestData
} from "../../api/global";

import Custom403 from '../403';

const DefaultNodeComponent = dynamic(() => import('../../components/04_templates/DefaultNode'));
import ReactPlaceholder from 'react-placeholder';

export async function getStaticProps(context) {
  const {params} = context;

  let initialProps = {
    statusCode: 200,
  };

  let data, node_data = {};

  try {
    // if (page_path) {
      // Page data about currently opened path.
      data = await getPageInfo(`/rent/rental-application-criteria`);

      if (data?.statusCode == 404) {
        return {
          notFound: true,
        };
      }

      // Check for any redirects:
      const regex1 = new RegExp('eatonrealty\.com|\.lndo\.site', 'ig');
      if (data?.page?.redirect && !regex1.test(data.page.redirect?.[0]?.to) && data?.page?.redirect?.length > 0) {
        return {
          redirect: {
            destination: data.page?.redirect[0]?.to,
            statusCode: parseInt(data.page?.redirect[0]?.status),
          },
        }
      }

      if (data?.page?.entity) {
        node_data = await getIndividualPageData(data.page.jsonapi.individual);

        if (node_data) {
          initialProps = {...initialProps, ...node_data};
        }
      }

      // Merge initially defined props with response from the backend.
      initialProps = {...initialProps, ...data};
    // }

    if (!data) {
      return {
        notFound: true,
      }
    }
  }
  catch (e) {
    console.warn('Aliased page retrieval error:', e);
    // Pass status code as internal properly. It is being checked inside of
    // render() method of _app.js.
    initialProps.statusCode = 500;

    // In case of Server Side Rendering, we want the server to throw the
    // correct error code.
    // if (res) {
    //   res.statusCode = 500;
    // }
  }

  let returnProps = {
    props: {
      ...initialProps,
    },
    revalidate: 900, // @todo: change for production back to 14400
    // notFound: true, // https://github.com/vercel/next.js/discussions/11862,
    // https://stackoverflow.com/questions/67946219/throw-new-errorfailed-to-load-static-props-when-setting-fallback-true-i/67946220#67946220
  };

  return returnProps;
}

function RentalCriteriaPage(props) {
  // @see 404 fallback:
  // https://github.com/vercel/next.js/discussions/10960#discussioncomment-22365
  const router = useRouter();
  if (router.isFallback) {
    return (
      // <main>
      <div className='container mx-auto'>
        <div>Loading...</div>
      </div>
      // </main>
    );
  }
  if (!props || !props?.page) {
    return (<Custom403/>);
  }

  let node_data, node, meta, terms, boundaries;

  if (props) {
    node = props?.page?.entity || null;
    meta = props?.metatags?.tags || [];

    if (node && props.page_data) {
      node_data = props.page_data;
    }
  }

  if (router?.query?.appid) {
    if (node_data?.body_json?.json) {
      const appUrl = (router.query.appid?.includes('http')) ? router.query.appid : decodeURIComponent(Buffer.from(router.query.appid, 'base64').toString());
      node_data.body_json.json[Object.keys(node_data?.body_json?.json).length] = {
        props: [],
        type: 'rendered_html',
        data: '<div class="text-center"><div class="IncBtn"><a href="' + appUrl + '">' +
            '<button class="MuiButtonBase-root MuiButton-root MuiButton-contained MuiButton-containedPrimary MuiButton-containedSizeLarge MuiButton-sizeLarge MuiButton-disableElevation" tabindex="0" type="button">' +
            '<span class="MuiButton-label"><span>CONTINUE</span> <strong>&nbsp;TO APPLICATION</strong></span><span class="MuiTouchRipple-root"></span>' +
            '</button></a></div></div>'
      };
    }
  }

  return (
    <div style={{minHeight: 1000}}>
      <ReactPlaceholder type='text' rows={40} ready={node_data?.internalId}
                        showLoadingAnimation={true}>
        {node && node_data &&
        <div className={`node node-type-${props?.page?.entity?.bundle} node-${props?.page?.entity?.id}`}>
          <DefaultNodeComponent node={node_data} metatags={meta}/>
        </div>
        }
        {(!node || !node_data) && props?.page?.label &&
        <div>
          <h1>{props.page.label}</h1>
          <p>Hmmm... Looks like something is missing here. We will update it
            soon.</p>
        </div>
        }
      </ReactPlaceholder>
    </div>
  );
}

export default RentalCriteriaPage;
